import React from 'react';
import './PageHeader.css';

/**
 * PageHeader Component - Consistent page header with title, breadcrumbs, and actions
 * 
 * @param {string} title - Main page title
 * @param {string} subtitle - Optional subtitle/description
 * @param {Array} breadcrumbs - Breadcrumb navigation [{label, onClick}]
 * @param {Array} actions - Action buttons [{label, onClick, className, disabled}]
 */
const PageHeader = ({ 
  title, 
  subtitle, 
  breadcrumbs, 
  actions 
}) => {
  return (
    <div className="page-header">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="breadcrumbs">
          {breadcrumbs.map((crumb, idx) => (
            <React.Fragment key={idx}>
              <button 
                className="breadcrumb-item"
                onClick={crumb.onClick}
              >
                {crumb.label}
              </button>
              {idx < breadcrumbs.length - 1 && (
                <span className="breadcrumb-separator">/</span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}

      <div className="page-header-content">
        <div className="page-header-title-section">
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>

        {actions && actions.length > 0 && (
          <div className="page-header-actions">
            {actions.map((action, idx) => (
              <button 
                key={idx}
                className={`action-button ${action.className || 'primary'}`}
                onClick={action.onClick}
                disabled={action.disabled}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="page-header-divider" />
    </div>
  );
};

export default PageHeader;
